import { Routes, Route, useNavigate } from 'react-router-dom';
import './App.css';
import LoginPage from './routes/Login/LoginPage';
import QrLoginPage from './routes/Login/QrLoginPage'
import PrivacyPage from './routes/Login/PrivacyPage';
import TermsPage from './routes/Login/TermsPage';
import UnitPage from './UnitsNav/UnitPage';
import Unit1 from './Unit1/Unit1Nav/Unit1Navigation';
import Unit2 from './Unit2/Unit2Nav/Unit2Navigation';
import Unit3 from './Unit3/Unit3Nav/Unit3Navigation';
import Unit4 from './Unit4/Unit4Nav/Unit4Navigation';
import Module1 from './Unit1/Module1/Module1World';
import Module1Nav from './Unit1/Module1/Module1Nav';
import Module2 from './Unit1/Module2/Module2World';
import Module2Nav from './Unit1/Module2/Module2Nav';
import Module2Practice from './Unit1/Module2/ListeningPractice';
import Module3 from './Unit1/Module3/Module3World';
import Module3Nav from './Unit1/Module3/Module3Nav';
import Module4 from './Unit1/Module4/Module4World';
import Module4Nav from './Unit1/Module4/Module4Nav';
import Module5 from './Unit1/Module5/Module5World';
import Module5Nav from './Unit1/Module5/Module5Nav';
import Module6 from './Unit2/Module6/Module6World';
import Module6Nav from './Unit2/Module6/Module6Nav';
import Module7 from './Unit2/Module7/Module7World';
import Module7Nav from './Unit2/Module7/Module7Nav';
import Module8 from './Unit2/Module8/Module8World';
import Module8Nav from './Unit2/Module8/Module8Nav';
import Module9 from './Unit2/Module9/Module9World';
import Module9Nav from './Unit2/Module9/Module9Nav';
import Module10 from './Unit2/Module10/Module10World';
import Module10Nav from './Unit2/Module10/Module10Nav';
import Module11 from './Unit3/Module11/Module11World';
import Module11Nav from './Unit3/Module11/Module11Nav';
import Module12 from './Unit3/Module12/Module12World';
import Module12Nav from './Unit3/Module12/Module12Nav';
import Module13 from './Unit3/Module13/Module13World';
import Module13Nav from './Unit3/Module13/Module13Nav';
import Module14 from './Unit3/Module14/Module14World';
import Module14Nav from './Unit3/Module14/Module14Nav';
import Module15 from './Unit3/Module15/Module15World';
import Module15Nav from './Unit3/Module15/Module15Nav';
import Module16 from './Unit4/Module16/Module16World';
import Module16Nav from './Unit4/Module16/Module16Nav';
import Module17 from './Unit4/Module17/Module17World';
import Module17Nav from './Unit4/Module17/Module17Nav';
import Module18 from './Unit4/Module18/Module18World';
import Module18Nav from './Unit4/Module18/Module18Nav';
import Module19 from './Unit4/Module19/Module19World';
import Module19Nav from './Unit4/Module19/Module19Nav';
import Module20 from './Unit4/Module20/Module20World';
import Module20Nav from './Unit4/Module20/Module20Nav';
import FreePlay from './FreePlay/FreePlay';
import Level1 from './FreePlay/Level1/Level1';
import Level2 from './FreePlay/Level2/Level2';
import Level3 from './FreePlay/Level3/Level3';
import Level4 from './FreePlay/Level4/Level4';
import Decorate1 from './FreePlay/Level1/Level1';
import Decorate2 from './FreePlay/Level2/Level2';
import Decorate3 from './FreePlay/Level3/Level3';   
import Decorate4 from './FreePlay/Level4/Level4';
import Example from './videos/example';

import { handleError } from './Error';
import { AuthenticatedRoute } from './AuthenticatedRoute/AuthenticatedRoute';
import React, { useState, useEffect } from 'react';
import { AppContext } from './Lib/contextLib';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useIdleTimer } from 'react-idle-timer';
//dialog
import { createTheme, ThemeProvider } from '@mui/material/styles';
import MediaOnboardingDialog from './MediaOnboardingDialog/MediaOnboardingDialog';

export function App() {
  if (window.location.hostname === 'www.wearefriends.cool') {
    window.location.href = 'https://wearefriends.cool';
  }
  const [isAuthenticated, userHasAuthenticated] = useState(false);
  const [countDown, setCountDown] = useState(60*60);
  document.title = 'We Are Friends';
  const handleOnIdle = () => {
    window.alert('Connection is lost. Please login again.');
    // dispatch({ type: 'CLEAR' });
    // navigate('/');
    window.location.reload(false);
  };
  const { getRemainingTime, getElapsedTime, getLastActiveTime } = useIdleTimer({
    // change back to 5 minutes
    timeout: 1000 * 60 * 10,
    onIdle: handleOnIdle,
    events: [
      'mousemove',
      'keydown',
      'wheel',
      'DOMMouseScroll',
      'mousewheel',
      'mousedown',
      'touchstart',
      'touchmove',
      'MSPointerDown',
      'MSPointerMove',
      'visibilitychange',
    ],
  });

  const [isIdle, setIsIdle] = useState(true);
  const [remaining, setRemaining] = useState(0);

  const theme = createTheme({
    components: {
      MuiButton: {
        styleOverrides: {
          root: { borderRadius: 20 },
        },
      },
      MuiDialog: {
        styleOverrides: {
          root: {
            borderRadius: 20,
          },
          paper: { borderRadius: 20, padding: 30 },
        },
      },
    },
    palette: {
      primary: {
        main: '#5568E5',
        dark: '#0a2463',
      },
      secondary: {
        main: '#CFDBFF',
      },
    },
    typography: {
      button: {
        textTransform: 'none',
      },
    },
  });

  function isIOS() {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }

  function isSafari() {
    const userAgent = navigator.userAgent.toLowerCase();
    const vendor = navigator.vendor.toLowerCase();
    
    // Don't block mobile devices (iOS or Android)
    const isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
    if (isMobile) {
      return false;
    }
    
    // Check if it's desktop Safari but not Chrome, Edge, or other Chromium-based browsers
    return (
      (userAgent.includes('safari') && !userAgent.includes('chrome')) ||
      (vendor.includes('apple') && userAgent.includes('safari') && !userAgent.includes('chrome'))
    );
  }

  // Safari blocking component
  function SafariBlocker() {
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        fontFamily: 'Arial, sans-serif'
      }}>
        <div style={{
          backgroundColor: 'white',
          padding: '40px',
          borderRadius: '20px',
          textAlign: 'center',
          maxWidth: '500px',
          margin: '20px'
        }}>
          <h2 style={{ color: '#ff4444', marginBottom: '20px' }}>
            ⚠️ Browser Not Supported
          </h2>
          <p style={{ fontSize: '18px', marginBottom: '20px', lineHeight: '1.5' }}>
            Safari is not supported for this application.
          </p>
          <p style={{ fontSize: '16px', marginBottom: '30px', color: '#666' }}>
            Please use <strong>Google Chrome</strong> for the best experience.
          </p>
          <a 
            href="https://www.google.com/chrome/"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-block',
              backgroundColor: '#4285f4',
              color: 'white',
              padding: '12px 24px',
              borderRadius: '8px',
              textDecoration: 'none',
              fontSize: '16px',
              fontWeight: 'bold'
            }}
          >
            Download Chrome
          </a>
        </div>
      </div>
    );
  }

  return (
    <>
      {isSafari() && <SafariBlocker />}
      <DndProvider backend={HTML5Backend}>
        <AppContext.Provider value={{ isAuthenticated, userHasAuthenticated }}>
          {isAuthenticated && !isIOS() && <ThemeProvider theme={theme}>
            <MediaOnboardingDialog />
          </ThemeProvider>}
          <Routes>
            <Route exact path='/example' element={<Example />} />
            <Route exact path='*' element={<handleError type= 'page' />} />
            <Route exact path='/' element={<LoginPage />} />
            <Route exact path='/login' element={<QrLoginPage />} />
            <Route exact path='/error' element={<handleError type='page' />} />
            <Route exact path='/terms' element={<TermsPage />} />
            <Route exact path='/privacy' element={<PrivacyPage />} />
            <Route exact path='/' element={<AuthenticatedRoute />}>
              <Route exact path='/unitPage' element={<UnitPage />} />
              <Route exact path='/unit1' element={<Unit1 />} />
              <Route exact path='/unit2' element={<Unit2 />} />
              <Route exact path='/unit3' element={<Unit3 />} />
              <Route exact path='/unit4' element={<Unit4 />} />
              <Route
                exact
                path='/eye-contact/navigation'
                element={<Module1Nav />}
              />
              <Route exact path='/eye-contact' element={<Module1 />} />
              <Route exact path='/listening' element={<Module2 />} />
              <Route
                exact
                path='/listening/practice'
                element={<Module2Practice />}
              />
              <Route
                exact
                path='/listening/navigation'
                element={<Module2Nav />}
              />
              <Route exact path='/facial-expression' element={<Module3 />} />
              <Route
                exact
                path='/facial-expression/navigation'
                element={<Module3Nav />}
              />
              <Route exact path='/posture' element={<Module4 />} />
              <Route
                exact
                path='/posture/navigation'
                element={<Module4Nav />}
              />
              <Route exact path='/distance' element={<Module5 />} />
              <Route
                exact
                path='/distance/navigation'
                element={<Module5Nav />}
              />
              <Route exact path='/greet' element={<Module6 />} />
              <Route exact path='/greet/navigation' element={<Module6Nav />} />
              <Route exact path='/answer' element={<Module7 />} />
              <Route exact path='/answer/navigation' element={<Module7Nav />} />
              <Route exact path='/ask' element={<Module8 />} />
              <Route exact path='/ask/navigation' element={<Module8Nav />} />
              <Route exact path='/respond' element={<Module9 />} />
              <Route
                exact
                path='/respond/navigation'
                element={<Module9Nav />}
              />
              <Route exact path='/close' element={<Module10 />} />
              <Route exact path='/close/navigation' element={<Module10Nav />} />
              <Route exact path='/feelings' element={<Module11 />} />
              <Route
                exact
                path='/feelings/navigation'
                element={<Module11Nav />}
              />
              <Route exact path='/understandfeelings' element={<Module12 />} />
              <Route
                exact
                path='/understandfeelings/navigation'
                element={<Module12Nav />}
              />
              <Route exact path='/changefeelings' element={<Module13 />} />
              <Route
                exact
                path='/changefeelings/navigation'
                element={<Module13Nav />}
              />
              <Route exact path='/solutions' element={<Module14 />} />
              <Route
                exact
                path='/solutions/navigation'
                element={<Module14Nav />}
              />
              <Route exact path='/activelistening' element={<Module15 />} />
              <Route
                exact
                path='/activelistening/navigation'
                element={<Module15Nav />}
              />
              <Route exact path='/manners' element={<Module16 />} />
              <Route
                exact
                path='/manners/navigation'
                element={<Module16Nav />}
              />
              <Route exact path='/friendsbullies' element={<Module17 />} />
              <Route
                exact
                path='/friendsbullies/navigation'
                element={<Module17Nav />}
              />
              <Route exact path='/resolveconflict' element={<Module18 />} />
              <Route
                exact
                path='/resolveconflict/navigation'
                element={<Module18Nav />}
              />
              <Route exact path='/selfadvocacy' element={<Module19 />} />
              <Route
                exact
                path='/selfadvocacy/navigation'
                element={<Module19Nav />}
              />
              <Route exact path='/caring' element={<Module20 />} />
              <Route
                exact
                path='/caring/navigation'
                element={<Module20Nav />}
              />
              <Route exact path='/freeplay' element={<FreePlay level={0}/>} />
              <Route exact path='/freeplay_2' element={<FreePlay level={1}/>} />
              <Route exact path='/freeplay_3' element={<FreePlay level={2}/>} />
              <Route exact path='/freeplay_4' element={<FreePlay level={3}/>} />
              <Route exact path='/freeplay/level1' element={<Level1 />} />
              <Route exact path='/freeplay/level1/decorate' element={<Decorate1 decorate={true}/>} />
              <Route exact path='/freeplay/level1/decorate/store' element={<Decorate1 store={true}/>} />
              <Route exact path='/freeplay/level2' element={<Level2 />} />
              <Route exact path='/freeplay/level2/decorate' element={<Decorate2 decorate={true}/>} />
              <Route exact path='/freeplay/level2/decorate/store' element={<Decorate2 store={true}/>} />
              <Route exact path='/freeplay/level3' element={<Level3 />} />
              <Route exact path='/freeplay/level3/decorate' element={<Decorate3 decorate={true}/>} />
              <Route exact path='/freeplay/level3/decorate/store' element={<Decorate3 store={true}/>} />
              <Route exact path='/freeplay/level4' element={<Level4 />} />
              <Route exact path='/freeplay/level4/decorate' element={<Decorate4 decorate={true}/>} />
              <Route exact path='/freeplay/level4/decorate/store' element={<Decorate4 store={true}/>} />
            </Route>
          </Routes>
        </AppContext.Provider>
      </DndProvider>
    </>
  );
}
